import { inject, Injectable, Injector } from '@angular/core';
import { ApiService } from './api.service';
import {
  BehaviorSubject,
  forkJoin,
  map,
  Observable,
  of,
  switchMap,
  catchError,
  throwError,
  timer,
  Subject,
} from 'rxjs';
import { ConfigurationManagerService } from './configuration-manager.service';
import { Perimeter, PerimeterResponse } from '../models/perimter.model';
import { HttpClient } from '@angular/common/http';
import { Organization, Facility } from '../models/model';
import {
  User,
  OrganizationData,
  Building,
  Floor,
  Room,
  Sensor,
  Camera,
  CameraModel,
  Group,
} from '../models/organization.interface';
import _ from 'lodash';
import { BuildingViewResponse } from '../models/building-view-response.model';
import { SessionOptionsService } from './session-option.service';
import { GlobalSettingsService } from './global-settings.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private organizationsSubject = new BehaviorSubject<Organization[]>([]);
  organizations$ = this.organizationsSubject.asObservable();

  private selectedOrgsSubject = new BehaviorSubject<Organization[]>([]);
  selectedOrgs$ = this.selectedOrgsSubject.asObservable();
  apiKey: string = ConfigurationManagerService.settings.BaseURL;
  findAndCount: string = ConfigurationManagerService.settings.FindAndCountAll;
  getUserStartTime: any;
  private _orgTree: any = null;
  private _managingOrgId: string | null = null;
  private orgTreeUpdatedSource = new Subject<void>();
  orgTreeUpdated$ = this.orgTreeUpdatedSource.asObservable();
  constructor(
    private api: ApiService,
    private http: HttpClient,       
    private globalSettings: GlobalSettingsService,
    private injector: Injector) {}


    setManagingOrgId(id: string): any {
    this._managingOrgId = id;
  }

    getPerimeters(): Observable<PerimeterResponse> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.PerimeterFindCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<PerimeterResponse>(url, body);
  }
  getOrganizations(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.OrganizationFindAndCountAll;
    const body = {
      where: {
        id: {
          $notIn: ['1', '2', '7'],
        },
      },
      order: [['id', 'ASC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }

  getOrganizationPerimeters(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.OrganizationPerimeterFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }

  OrganizationContactFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.OrganizationContactFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }

  GroupFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.GroupFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  PerimeterContactFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.PerimeterContactFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  PerimeterSafezoneFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.PerimeterSafezoneFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  savePerimeterSafezone(perimeterSafezone: any): Observable<any> {
    const url = ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.PerimeterSafezoneFindAndCountAll;;
    return this.api.post<any>(url, perimeterSafezone);
  }
  BuildingFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.BuildingFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  FloorFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.FloorFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  FloorPlanFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.FloorPlanFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  GeofenceFindAndCountAllFromOrganization(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings
        .GeofenceFindAndCountAllFromOrganization;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  BeaconFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.BeaconFindAndCountAll;
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  buildingPointLocations(orgPerimeters: any[], orgId: string): any[] {
    orgPerimeters = orgPerimeters || [];

    return orgPerimeters
      .filter((perimeter) => perimeter.type === 'BUILDING')
      .map((perimeter) => {
        // grab center of building poly
        //const polygon = turf.polygon(perimeter.geometry.coordinates);
        //const buildingCenterMass = turf.centerOfMass(polygon);
        const buildingRecord = perimeter.building || {
          id: perimeter.id,
          address: '',
        };
        return {
          label: perimeter.label,
          locationType: 'facility',
          attributes: {
            bluetooth: true,
            facilityId: buildingRecord.id,
            basePerimeterId: perimeter.id,
            own: false,
            //sops: ["@TODO PAPI does not have facility.sops"],
            poc: perimeter.pocs,
            address: buildingRecord.address,
            ratings: {},
            weatherIndicator: undefined,
            extraInformation: undefined,
          },
          geometry: null, //buildingCenterMass.geometry,
          organizationId: orgId,
          createdBy: '',
          id: perimeter.id,
          buildingId: buildingRecord.id,
          createdAt: perimeter.createdAt,
          updatedAt: perimeter.updatedAt,
          archived: false,
        };
      });
  }

  loadOrganizations(): Observable<Organization[]> {
    return this.api
      .get<Organization[]>(
        `${this.apiKey + ConfigurationManagerService.settings.Organization}${
          this.findAndCount
        }`
      )
      .pipe(
        map((orgs) => {
          this.organizationsSubject.next(orgs);
          return orgs;
        })
      );
  }

  getOrganizationById(id: string): Observable<Organization> {
    return this.api.get<Organization>(`${this.apiKey}organizations/${id}`);
  }

  getOrganizationUserCount(orgId: string): Observable<number> {
    return this.api.get<number>(
      `${this.apiKey}organizations/${orgId}/users/count`
    );
  }

  searchOrganizations(query: string) {
    // return this.api.get<Organization[]>(`${this.apiKey}organizations/search`, {
    //   params: { query },
    // });
  }
  getSelectedOrganizationsCount(): number {
    return this.selectedOrgsSubject.value.length;
  }
  sendMessageToOrganization(orgId: string, message: string): Observable<any> {
    return this.api.post(`${this.apiKey}organizations/${orgId}/message`, {
      message,
    });
  }

  toggleOrganizationSelection(org: Organization): void {
    const currentOrgs = this.selectedOrgsSubject.value;
    const index = currentOrgs.findIndex((o) => o.id === org.id);

    if (index === -1) {
      this.selectedOrgsSubject.next([...currentOrgs, org]);
    } else {
      currentOrgs.splice(index, 1);
      this.selectedOrgsSubject.next([...currentOrgs]);
    }
  }

  getSelectedOrganizations(): Organization[] {
    return this.selectedOrgsSubject.value;
  }

  clearSelectedOrganizations(): void {
    this.selectedOrgsSubject.next([]);
  }

  getOrgUsers(): Observable<{ rows: User[]; count: number }> {
    const body = {
      attributes: ['id', 'name'],
      order: [['name', 'DESC']],
      limit: 10000,
    };

    return this.api.post<{ rows: User[]; count: number }>(
      this.apiKey + ConfigurationManagerService.settings.OrgUserList,
      body
    );
  }
getPhoneNumbers(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.PhoneNumbers;
    const body = {
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }  
  
  getAllUsersForOrgViaAPI(): Observable<any[]> {
    const startTime = Date.now();
    this.getUserStartTime = startTime;

    return this.getAllUsersWithOrganization().pipe(
      switchMap((allData: any[]) => {
        const items = allData.map((row: any) => ({
          userId: parseInt(row.id, 10),
          name: row.name,
          companyName: row.UserOrganizations?.[0]?.Organization?.name ?? '',
          orgId: parseInt(row.UserOrganizations?.[0]?.Organization?.id ?? '0', 10),
          orgIds: _.map(row.UserOrganizations, (uo: any) => uo.Organization.id),
        }));

        this.data.allUserInfo = items;
        if (this.globalSettings?.setNumberOfUsersFiltered) {
          this.globalSettings.setNumberOfUsersFiltered(items.length);
        }

        return this.findUserPhonesPaginated().pipe(
          map((phones: any[]) => {
            const userPhoneDict: Record<string, boolean> = {};
            const userPhoneListDict: Record<string, any[]> = {};

            phones.forEach((phone: any) => {
              if (!userPhoneDict[phone.userId]) {
                userPhoneDict[phone.userId] = (phone.type === 'mobile');
              }
              if (!userPhoneListDict[phone.userId]) {
                userPhoneListDict[phone.userId] = [];
              }
              userPhoneListDict[phone.userId].push(phone);
            });

            this.data.allUserInfoDictionary = {};
            items.forEach((user: any) => {
              user.hasMobilePhone = userPhoneDict[user.userId + ''] ?? false;
              if (userPhoneListDict[user.userId]) {
                user.phones = userPhoneListDict[user.userId];
              }
              this.data.allUserInfoDictionary[user.userId + ''] = user;
            });

            let companyList = items.map((user: any) => ({
              orgId: user.orgId,
              companyName: user.companyName,
            }));
            companyList = _.uniqBy(companyList, (o) => o.orgId);
            companyList = _.sortBy(companyList, (o) => o.companyName);
            this.data.companylist = companyList;

            const endTime = Date.now();

            this.populateGeoInfoForUsers(items);

            return items;
          })
        );
      }),
      catchError((error) => {
        console.error(error);
        return of([]);
      })
    );
  }
  getAllUsersWithOrganization(): Observable<any[]> {
    const url = this.apiKey + 'db/User/findAndCountAllWithOrganizationFromOrganization';
    const body = {
      attributes: ['id', 'name', 'UserOrganizations'],
      order: [['name', 'DESC']],
      limit: 10000,
      offset: 0
    };
    return this.api.paginateApi<any>(url, body);
  }
  findUserPhonesPaginated(): Observable<any[]> {
    const url = this.apiKey + ConfigurationManagerService.settings.PhoneNumbers;
    const body = { limit: 10000, offset: 0 };
    return this.api.paginateApi<any>(url, body);
}
    getEntireUsers(): Observable<any> {
      const url = this.apiKey + ConfigurationManagerService.settings.OrgUserList;
      const body = {
        attributes: ['id', 'name', 'UserOrganizations'],
        order: [['name', 'DESC']],
        limit: 100000,
      };
      return this.api.post<any>(url, body);
    }

    findUserPhones(): Observable<any> {
      const url = this.apiKey + ConfigurationManagerService.settings.PhoneNumbers;
      const body = { limit: 100000 };
      return this.api.post<any>(url, body);
    }

   populateGeoInfoForUsers(items: any[]): void { 
    const sessionOptionsService = this.injector.get(SessionOptionsService);
    sessionOptionsService.getArcliveActions().subscribe((actions: string[]) => {
      if (!actions.includes(sessionOptionsService.ArcliveActions.arclive_feature_showHomeLocations)) {
        return;
      }

      const homeLocationsAllDictionary = this.globalSettings?.getHomeLocationsAllDictionary?.();
      if (!homeLocationsAllDictionary) {
        timer(1000).subscribe(() => this.populateGeoInfoForUsers(items));
        return;
      }

      items.forEach((item: any) => {
        const geo = homeLocationsAllDictionary[item.userId || ''];
        if (geo) {
          item.geo = geo;
        }
      });
    });
  }
  getPerimeterIds(): Observable<string[]> {
    return this.api
      .post<{ rows: Sensor[] }>(
        `${
          this.apiKey + ConfigurationManagerService.settings.SensorFindCountAll
        }`,
        {}
      )
      .pipe(
        map((response) => response.rows.map((sensor) => sensor.perimeterId)),
        map((ids) => Array.from(new Set(ids))) // unique
      );
  }

  findPerimetersByIdsOrDescendants(
    perimeterIds: string[]
  ): Observable<Perimeter[]> {
    const payload = {
      attributes: [
        'id',
        'parentId',
        'ancestors',
        'descendants',
        'type',
        'label',
      ],
      where: {
        $or: [
          { descendants: { $overlap: perimeterIds } },
          { id: perimeterIds },
        ],
      },
    };
    return this.api
      .post<{ rows: Perimeter[] }>(
        `${
          this.apiKey +
          ConfigurationManagerService.settings.PerimeterFindCountAll
        }`,
        payload
      )
      .pipe(map((response) => response.rows));
  }
  // 1. Get all organizations with perimeters and buildings
  getOrganizationsWithPerimeters(): Observable<any[]> {
    return this.api
      .get<{ rows: any[] }>(
        `${
          this.apiKey +
          ConfigurationManagerService.settings.PerimeterFindCountAll
        }`
      )
      .pipe(map((res) => (Array.isArray(res.rows) ? res.rows : [])));
  }

  getBuildingViewsAndTiles(): Observable<{
    buildingViews: any[];
    buildingTiles: any[];
  }> {
    return forkJoin({
      buildingViews: this.api
        .get<{ rows: any[] }>(`${this.apiKey}db/BuildingView/findAndCountAll`)
        .pipe(map((res) => (Array.isArray(res.rows) ? res.rows : []))),
      buildingTiles: this.api
        .get<{ rows: any[] }>(`${this.apiKey}db/BuildingTile/findAndCountAll`)
        .pipe(map((res) => (Array.isArray(res.rows) ? res.rows : []))),
    });
  }

  getFacilities(): Observable<Facility[]> {
    const payload = {
      order: [['id', 'DESC']],
      limit: 10000,
    };

    return this.api
      .post<{ rows: any[] }>(
        `${
          this.apiKey +
          ConfigurationManagerService.settings.PerimeterFindCountAll
        }`,
        payload
      )
      .pipe(
        map((res) => (Array.isArray(res.rows) ? res.rows : [])),
        map((perimeters) =>
          perimeters
            .filter((p: any) => p.type === 'BUILDING')
            .map(
              (perimeter: any) =>
                ({
                  id: perimeter.id,
                  label: perimeter.label,
                  organizationId: perimeter.parentId ?? '',
                  buildingId: perimeter.building?.id ?? perimeter.id,
                  coordinates:
                    perimeter.building?.position?.coordinates ||
                    (perimeter.geometry &&
                    Array.isArray(perimeter.geometry.coordinates)
                      ? Array.isArray(perimeter.geometry.coordinates[0])
                        ? perimeter.geometry.coordinates[0][0]
                        : perimeter.geometry.coordinates[0]
                      : []),
                  address: perimeter.building?.address ?? '',
                } as Facility)
            )
        )
      );
  }
  getCampuses(): Observable<Facility[]> {
    const payload = {
      order: [['id', 'DESC']],
      limit: 10000,
    };

    return this.api
      .post<{ rows: any[] }>(
        `${
          this.apiKey +
          ConfigurationManagerService.settings.PerimeterFindCountAll
        }`,
        payload
      )
      .pipe(
        map((res) => (Array.isArray(res.rows) ? res.rows : [])),
        map((perimeters) =>
          perimeters
            .filter((p: any) => p.type === 'CAMPUS')
            .map(
              (perimeter: any) =>
                ({
                  id: perimeter.id,
                  label: perimeter.label,
                  organizationId: perimeter.parentId ?? '',
                  buildingId: perimeter.building?.id ?? perimeter.id,
                  coordinates:
                    perimeter.building?.position?.coordinates ||
                    (perimeter.geometry &&
                    Array.isArray(perimeter.geometry.coordinates)
                      ? Array.isArray(perimeter.geometry.coordinates[0])
                        ? perimeter.geometry.coordinates[0][0]
                        : perimeter.geometry.coordinates[0]
                      : []),
                  address: perimeter.building?.address ?? '',
                } as Facility)
            )
        )
      );
  }
  public data: OrganizationData = {
    myName: '',
    myId: '',
    myPermissions: {},
    myOrgs: {},
    myOrgIds: [],
    papiPerimeters: {},
    mySOPs: {},
    myAllUsers: [],
    allSensors: [],
    sensorList: undefined,
    allUserInfo: [],
    allUserInfoDictionary: {},
    companylist: [],
  };

  getCameraList(): Observable<CameraModel[]> {
    const body = {
      order: [['id', 'DESC']],
      limit: 10000,
    };
    return this.api
      .post<{ rows: any[]; count: number }>(
        `${
          this.apiKey + ConfigurationManagerService.settings.SensorFindCountAll
        }`,
        body
      )
      .pipe(
        map((res) => (Array.isArray(res.rows) ? res.rows : [])),
        map((cameras) => cameras.filter((cam) => cam.type === 'CAMERA')),
        map((cameras) =>
          cameras.map(
            (cam) =>
              ({
                id: cam.id,
                label: cam.label,
                labelShort: this.getShortLabel(cam.label),
                building: cam.building
                  ? {
                      id: cam.building.id,
                      label: cam.building.label,
                      labelShort: this.getShortLabel(cam.building.label),
                    }
                  : undefined,
                floor: cam.floor
                  ? {
                      id: cam.floor.id,
                      label: cam.floor.label,
                      number: cam.floor.number,
                    }
                  : undefined,
                room: cam.room
                  ? {
                      id: cam.room.id,
                      label: cam.room.label,
                      labelShort: this.getShortLabel(cam.room.label),
                    }
                  : undefined,
                position: cam.position,
              } as CameraModel)
          )
        )
      );
  }

  getBuildings(): Observable<Building[]> {
    return this.getCameraList().pipe(
      map((cameras) => {
        const buildings = new Map<string, Building>();
        cameras.forEach((camera) => {});
        return Array.from(buildings.values());
      })
    );
  }

  getFloorsForBuilding(buildingId: string): Observable<Floor[]> {
    return this.getCameraList().pipe(
      map((cameras) => {
        const floors = new Map<string, Floor>();
        cameras
          .filter((camera) => camera.building?.id === buildingId)
          .forEach((camera) => {
            if (
              camera.floor &&
              camera.floor.id &&
              !floors.has(camera.floor.id)
            ) {
              floors.set(camera.floor.id, {
                id: camera.floor.id,
                label: camera.floor.label,
                number: camera.floor.number,
                numberCamera: 1, // or calculate actual count if needed
                buildingId: camera.building?.id || '',
                rooms: [],
              });
            }
          });
        return Array.from(floors.values());
      })
    );
  }

  getRoomsForFloor(floorId: string): Observable<Room[]> {
    return this.getCameraList().pipe(
      map((cameras) => {
        const rooms = new Map<string, Room>();
        cameras
          .filter((camera) => camera.floor?.id === floorId)
          .forEach((camera) => {
            if (camera.room && camera.room.id && !rooms.has(camera.room.id)) {
              rooms.set(camera.room.id, {
                id: camera.room.id,
                label: camera.room.label,
                labelShort: camera.room.labelShort || '',
                numberCamera: 1, // or calculate actual count if needed
                floorId: camera.floor?.id || '',
                buildingId: camera.building?.id || '',
              });
            }
          });
        return Array.from(rooms.values());
      })
    );
  }

  private getShortLabel(label: string): string {
    return label && label.length > 20 ? `${label.substring(0, 20)}...` : label;
  }

  // Action methods
  showAdHocVideo(): void {
  }

  viewPerimeter(camera: Camera): void {
    // Implement perimeter view functionality
  }

  viewInfo(camera: Camera): void {
    // Implement camera info view functionality
  }

  playVideo(camera: Camera): void {
    // Implement video playback functionality
  }
  private _sensorList: any;

  getSensorList(): Observable<any> {
    if (this._sensorList) {
      return of(this._sensorList);
    }

    let sensorInfo: any[];
    let perimeterInfo: any[];
    let cameraInfo: any[];
    let cameraList1: any;

    const param = {
      order: [['id', 'DESC']],
      limit: 10000,
    };

    return this.api
      .post<{ data: any; rows: any[]; count: number }>(
        `${
          this.apiKey + ConfigurationManagerService.settings.SensorFindCountAll
        }`,
        param
      )
      .pipe(
        switchMap((results) => {
          sensorInfo = results?.rows;
          const perimeterIds = _.uniq(sensorInfo.map((s) => s.perimeterId));
          const sensorIds = _.uniq(
            sensorInfo.filter((o) => o.type === 'CAMERA').map((o) => o.id)
          );

          const param1 = {
            attributes: [
              'id',
              'parentId',
              'ancestors',
              'descendants',
              'type',
              'label',
            ],
            where: {
              $or: [
                { descendants: { $overlap: perimeterIds } },
                { id: perimeterIds },
              ],
            },
          };
          const param2 = {
            where: {
              sensorId: sensorIds,
            },
          };

          return forkJoin({
            perimeters: this.api.post<{ rows: any }>(
              `${
                this.apiKey +
                ConfigurationManagerService.settings.PerimeterFindCountAll
              }`,
              param1
            ),
            cameras: this.api.post<{ rows: any }>(
              `${this.apiKey}db/Camera/findAndCountAll `,
              param2
            ),
          });
        }),
        switchMap((results) => {
          perimeterInfo = results.perimeters.rows;
          cameraInfo = results.cameras.rows;

          perimeterInfo.forEach((p: any) => {
            if (p.type === 'BUILDING') {
              p.labelShort = p.label.slice(0, 18);
            } else if (p.type === 'FLOOR' || p.type === 'ROOM') {
              p.labelShort = p.label.slice(0, 10);
            }
          });

          cameraList1 = this.parseCameraInfo(
            cameraInfo,
            sensorInfo,
            perimeterInfo
          );
          const buildingPerimeterIds = _.uniq(
            cameraList1.buildings.map((b: any) => b.id)
          );
          return this.getOrganizationByPerimeterIds(
            buildingPerimeterIds as string[]
          );
        }),
        switchMap((results) => {
          const orgsForPerimeter = _.groupBy(results.rows, 'perimeterId');
          Object.keys(orgsForPerimeter).forEach((key) => {
            orgsForPerimeter[key] = orgsForPerimeter[key].map(
              (o: any) => o.organizationId
            );
          });

          cameraList1.cameraList.forEach((c: any) => {
            c.building.organizationIds = orgsForPerimeter[c.building.id];
          });
          cameraList1.buildings.forEach((b: any) => {
            b.organizationIds = orgsForPerimeter[b.id];
          });

          // Get floor info
          const floorPerimeters = _.flatMap(cameraList1.buildings, 'floors');
          const floorPerimeterIds = floorPerimeters.map((f: any) => f.id);

          const floorParam = {
            where: {
              perimeterId: floorPerimeterIds,
            },
          };
          return this.api.post<{ rows: any }>(
            `${this.apiKey}db/Floor/findAndCountAll`,
            floorParam
          );
        }),
        map((results) => {
          const floorNumberDictionary: { [key: string]: number } = {};
          results?.rows.forEach((floor: any) => {
            floorNumberDictionary[floor.perimeterId] = floor.number;
          });

          cameraList1.buildings.forEach((b: any) => {
            b.floors.forEach((floor: any) => {
              floor.number = floorNumberDictionary[floor.id];
            });
          });
          cameraList1.cameraList.forEach((c: any) => {
            c.floor.number = floorNumberDictionary[c.floor.id];
          });

          this._sensorList = cameraList1;
          this.data.sensorList = cameraList1;
          return this._sensorList;
        })
      );
  }
  getOrganizationByPerimeterIds(perimeterIds: string[]): Observable<any> {
    const param = {
      attributes: ['perimeterId', 'organizationId'],
      where: { perimeterId: perimeterIds },
      limit: 10000,
    };
    return this.api.post<{ data: any }>(
      `${this.apiKey}db/OrganizationPerimeter/findAndCountAll`,
      param
    );
  }

  private parseCameraInfo(
    cameraInfo: any[],
    sensorInfo: any[],
    perimeterInfo: any[]
  ): any {
    sensorInfo.forEach((sensor) => {
      sensor.camera = cameraInfo.filter((o) => o.sensorId === sensor.id);
    });

    // Get buildings
    const buildings = perimeterInfo.filter((o) => o.type === 'BUILDING');
    buildings.forEach((building) => {
      building.numberCamera = 0;
      building.numberAccessControl = 0;
      building.numberRaspberryPi = 0;
      building.attachedCameras = sensorInfo.filter(
        (o) => o.perimeterId === building.id && o.type === 'CAMERA'
      );
      building.attachedRaspberryPis = sensorInfo.filter(
        (o) => o.perimeterId === building.id && o.type === 'RASPBERRY_PI'
      );
      building.attachedAccessControls = sensorInfo.filter(
        (o) => o.perimeterId === building.id && o.type !== 'CAMERA' && o.type !== 'RASPBERRY_PI'
      );
      building.floors = perimeterInfo.filter(
        (o) =>
          o.type === 'FLOOR' &&
          Array.isArray(building.descendants) &&
          building.descendants.includes(o.id)
      );
      building.floors.forEach(
        (floor: {
          attachedCameras: string | any[];
          id: any;
          attachedAccessControls: string | any[];
          attachedRaspberryPis?: string | any[];
          numberCamera: any;
          numberAccessControl: any;
          numberRaspberryPi?: any;
          rooms: any[];
          descendants: string | any[];
        }) => {
          floor.attachedCameras = sensorInfo.filter(
            (o) => o.perimeterId === floor.id && o.type === 'CAMERA'
          );
          floor.attachedRaspberryPis = sensorInfo.filter(
            (o) => o.perimeterId === floor.id && o.type === 'RASPBERRY_PI'
          );
          floor.attachedAccessControls = sensorInfo.filter(
            (o) => o.perimeterId === floor.id && o.type !== 'CAMERA' && o.type !== 'RASPBERRY_PI'
          );
          floor.numberCamera = floor.attachedCameras.length;
          floor.numberRaspberryPi = floor.attachedRaspberryPis.length;
          floor.numberAccessControl = floor.attachedAccessControls.length;
          floor.rooms = perimeterInfo.filter(
            (o) =>
              o.type === 'ROOM' &&
              Array.isArray(floor.descendants) &&
              floor.descendants.includes(o.id)
          );

          floor.rooms.forEach((room) => {
            room.attachedCameras = sensorInfo.filter(
              (o) => o.perimeterId === room.id && o.type === 'CAMERA'
            );
            room.attachedRaspberryPis = sensorInfo.filter(
              (o) => o.perimeterId === room.id && o.type === 'RASPBERRY_PI'
            );
            room.attachedAccessControls = sensorInfo.filter(
              (o) => o.perimeterId === room.id && o.type !== 'CAMERA' && o.type !== 'RASPBERRY_PI'
            );
            room.numberCamera = room.attachedCameras.length;
            room.numberRaspberryPi = room.attachedRaspberryPis.length;
            room.numberAccessControl = room.attachedAccessControls.length;
            floor.numberCamera += room.attachedCameras.length;
            floor.numberRaspberryPi += room.attachedRaspberryPis.length;
            floor.numberAccessControl += room.attachedAccessControls.length;
          });
          building.numberCamera += floor.numberCamera;
          building.numberRaspberryPi += floor.numberRaspberryPi;
          building.numberAccessControl += floor.numberAccessControl;
        }
      );
    });

    // Camera, access control, and raspberry pi lists
    let cameraList: any[] = [];
    let accessControlList: any[] = [];
    let raspberryPiList: any[] = [];
    buildings.forEach((building) => {
      building.attachedCameras.forEach((camera: any) => {
        camera.building = {
          id: building.id,
          label: building.label,
          labelShort: building.labelShort,
        };
        cameraList.push(camera);
      });
      building.attachedRaspberryPis?.forEach((rpi: any) => {
        rpi.building = {
          id: building.id,
          label: building.label,
          labelShort: building.labelShort,
        };
        raspberryPiList.push(rpi);
      });
      building.attachedAccessControls.forEach((camera: any) => {
        camera.building = {
          id: building.id,
          label: building.label,
          labelShort: building.labelShort,
        };
        accessControlList.push(camera);
      });
      building.floors.forEach(
        (floor: {
          attachedCameras: any[];
          id: any;
          label: any;
          labelShort: any;
          attachedAccessControls: any[];
          attachedRaspberryPis?: any[];
          rooms: any[];
        }) => {
          floor.attachedCameras.forEach((camera: any) => {
            camera.building = {
              id: building.id,
              label: building.label,
              labelShort: building.labelShort,
            };
            camera.floor = {
              id: floor.id,
              label: floor.label,
              labelShort: floor.labelShort,
            };
            cameraList.push(camera);
          });
          floor.attachedRaspberryPis?.forEach((rpi: any) => {
            rpi.building = {
              id: building.id,
              label: building.label,
              labelShort: building.labelShort,
            };
            rpi.floor = {
              id: floor.id,
              label: floor.label,
              labelShort: floor.labelShort,
            };
            raspberryPiList.push(rpi);
          });
          floor.attachedAccessControls?.forEach((camera: any) => {
            camera.building = {
              id: building.id,
              label: building.label,
              labelShort: building.labelShort,
            };
            camera.floor = {
              id: floor.id,
              label: floor.label,
              labelShort: floor.labelShort,
            };
            accessControlList.push(camera);
          });
          floor.rooms.forEach((room) => {
            room.attachedCameras.forEach((camera: any) => {
              camera.building = {
                id: building.id,
                label: building.label,
                labelShort: building.labelShort,
              };
              camera.floor = {
                id: floor.id,
                label: floor.label,
                labelShort: floor.labelShort,
              };
              camera.room = {
                id: room.id,
                label: room.label,
                labelShort: room.labelShort,
              };
              camera.buildingLabel = building.label;
              camera.floorLabel = floor.label;
              camera.roomLabel = room.label;
              cameraList.push(camera);
            });
            room.attachedRaspberryPis?.forEach((rpi: any) => {
              rpi.building = {
                id: building.id,
                label: building.label,
                labelShort: building.labelShort,
              };
              rpi.floor = {
                id: floor.id,
                label: floor.label,
                labelShort: floor.labelShort,
              };
              rpi.room = {
                id: room.id,
                label: room.label,
                labelShort: room.labelShort,
              };
              rpi.buildingLabel = building.label;
              rpi.floorLabel = floor.label;
              rpi.roomLabel = room.label;
              raspberryPiList.push(rpi);
            });
            room.attachedAccessControls.forEach((camera: any) => {
              camera.building = {
                id: building.id,
                label: building.label,
                labelShort: building.labelShort,
              };
              camera.floor = {
                id: floor.id,
                label: floor.label,
                labelShort: floor.labelShort,
              };
              camera.room = {
                id: room.id,
                label: room.label,
                labelShort: room.labelShort,
              };
              camera.buildingLabel = building.label;
              camera.floorLabel = floor.label;
              camera.roomLabel = room.label;
              accessControlList.push(camera);
            });
          });
        }
      );
    });

    cameraList.forEach((c) => {
      c.labelShort = c.label.slice(0, 15);
      c.url = Array.isArray(c.camera) && c.camera.length > 0 ? c.camera[0].url : '';
    });
    cameraList = _.sortBy(cameraList, [
      'buildingLabel',
      'floorLabel',
      'roomLabel',
      'label',
    ]);
    raspberryPiList.forEach((c) => {
      c.labelShort = c.label.slice(0, 15);
    });
    raspberryPiList = _.sortBy(raspberryPiList, [
      'buildingLabel',
      'floorLabel',
      'roomLabel',
      'label',
    ]);
    accessControlList.forEach((c) => {
      c.labelShort = c.label.slice(0, 15);
    });
    accessControlList = _.sortBy(accessControlList, [
      'buildingLabel',
      'floorLabel',
      'roomLabel',
      'label',
    ]);

    return { buildings, cameraList, accessControlList, raspberryPiList };
  }

  findRaspberryPi(params: any = {}): Observable<any> {
    const url = `${this.apiKey}db/RaspberryPi/findAndCountAll`;
    return this.api.post<any>(url, params);
  }

  getRaspberryPi(id: string | number): Observable<any> {
    const url = `${this.apiKey}db/RaspberryPi/${id}`;
    return this.api.get<any>(url);
  }

  getOrgTree(): Observable<any> {
    if (this._orgTree) {
      return of(this._orgTree);
    }

    const startTime = Date.now();
    const body = { limit: 10000 };

    return forkJoin({
      organizations: this.getOrganizations(),
      groups: this.api.post<any>(
        `${this.apiKey}db/Group/findAndCountAll`,
        body
      ),
    }).pipe(
      map((response) => {
        const organizations = response.organizations.rows || [];
        const groups = response.groups.rows || [];
        const selectedOrgs = organizations.map((org: any) => org.id);

        this._orgTree = {
          organizations,
          groups,
          selectedOrgs,
        };

        const endTime = Date.now();

        return this._orgTree;
      }),
      catchError((error) => {
        console.error('Error getting Org Tree', error);
        return throwError(() => error);
      })
    );
  }
  // Building View Find and Count All
  BuildingViewFindAndCountAll(): Observable<BuildingViewResponse> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.BuildingViewFindAndCountAll;
    const body = {
      limit: 10000,
    };
    return this.api.post<BuildingViewResponse>(url, body);
  }
  // Building Tile Find and Count All
  BuildingTileFindAndCountAll(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.BuildingTileFindAndCountAll;
    const body = {
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  getOrganizationCampus(organizationId: any): Observable<any> {
    const url =
        ConfigurationManagerService.settings.TezAddPapiBaseUrl +
        ConfigurationManagerService.settings.GetOrganizationCampus;
    const body = {
        organization_ids: Array.isArray(organizationId) ? organizationId : [organizationId],
        order: [
        [
          "building_id",
          "desc"
        ]
      ]
    };
    return this.api.post<any>(url, body);
  }

  
  getProfilesFromOrganization(userId: string): Observable<any> {
    const id = userId == null ? '' : String(userId).trim();
    if (!id || id === 'null' || id === 'undefined') {
      return of(null);
    }
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.Profile +
      `/${id}/profileFromOrganization`;
    return this.api.post<any>(url, null);
  }

  getUserPicture(userId: string): Observable<Blob> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.UserPicture +
      `/${userId}/file?attachment=true`;
    return this.http.get(url, { responseType: 'blob' });
  }
 getMessageTemplate(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.MessageTemplate;
    const body = {
      type: 'CUSTOM',
      limit: 10000,
    };
    return this.api.post<any>(url, body); //   send empty object instead of null
  }
  getEmergencyNumber(): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.OrganizationPhone;

 
    return this.api.post<PerimeterResponse>(url, null); //   send empty object instead of null
  }
  getSuspectDetailByPhoneNumber(phoneNumber: string): Observable<any> {
    const url =
      ConfigurationManagerService.settings.TezAddPapiBaseUrl +
      ConfigurationManagerService.settings.SuspectDetailByPhoneNumber + `${phoneNumber}`;
    return this.api.get<any>(url).pipe(
      catchError((error) => {
        console.error('Error fetching suspect details:', error);
        return of(null); // Return null or an empty object on error
      })
    );
  }
  
// SOP
  getSOP(alertId: string): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.SopTask;
    const body = {
      attributes: [
        "label",
        "description",
        "sopId",
        "createdAt",
        "updatedAt"
      ],
      where: {
        "alertId": alertId
      },
      limit: 10000,
    };
    return this.api.post<any>(url, body);
  }
  dismissAlert(alertId: string): Observable<any> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.AlertDismiss + `${alertId}`;
    const body = {
      dismissedAt: new Date().toISOString(),
    };
    return this.api.patch<any>(url, body);
  }
  public clearUserData(): void {
    this._orgTree = null;
  }

  // Activate safezone
  activateSafezone(eventId: string, safezoneId: string, orgId: string): Observable<any> {
    const cleanSafezoneId = String(safezoneId).replace(/^arc-angel-(playback-)?/, '');
    return this.establishIncidentOrgForLiveMode(eventId, orgId).pipe(
      switchMap(resolvedOrgId => {
        const baseUrl = ConfigurationManagerService.settings?.BaseURL;
        const endpoint = ConfigurationManagerService.settings?.Activate;
        const safeZoneEndpoint = ConfigurationManagerService.settings?.safeZone;
        const url = `${baseUrl}${safeZoneEndpoint}${cleanSafezoneId}/${endpoint}`;
        const body = { organizationId: String(resolvedOrgId) };
        return this.http.patch<any>(url, body);
      })
    );
  }

  // Deactivate safezone
  deactivateSafezone(eventId: string, safezoneId: string, orgId: string): Observable<any> {
    return this.establishIncidentOrgForLiveMode(eventId, orgId).pipe(
      switchMap(resolvedOrgId => {
        const baseUrl = ConfigurationManagerService.settings?.BaseURL;
        const endpoint = ConfigurationManagerService.settings?.DeactivateSafezone;
        const safeZoneEndpoint = ConfigurationManagerService.settings?.safeZone;
        const url = `${baseUrl}${safeZoneEndpoint}/${safezoneId}/${endpoint}`;
        const body = { organizationId: String(resolvedOrgId) };
        return this.http.patch<any>(url, body);
      })
    );
  }

  // Establish organization for live mode
  establishIncidentOrgForLiveMode(incidentId: string, orgId: string): Observable<string> {
    if (orgId) {
      return of(orgId);
    }

    const params = {
      body: {
        attributes: ['organizationId'],
        order: [['createdAt', 'ASC']],
        where: { incidentId: incidentId } 
      }
    };

    const incidentOrgs$ = this.http.post<any>(
      `${ConfigurationManagerService.settings.BaseURL}db/findIncidentOrganization`,
      params
    ).pipe(
      map(res => res.data.rows.map((org: any) => org.organizationId))
    );

    const perimeterIncidentOrgs$ = this.getPerimeterIncidentOrgs(incidentId);

    return forkJoin([incidentOrgs$, perimeterIncidentOrgs$]).pipe(
      switchMap(([incidentOrgs, perimeterOrgs]) => {
        const allPotentialOrgs = [...new Set([...incidentOrgs, ...perimeterOrgs])];
        return this.establishOrgIdToUseForLiveMode(allPotentialOrgs); // now correctly flattened
      })
    );
  }

  // Get perimeter orgs for an incident
  getPerimeterIncidentOrgs(incidentId: string): Observable<string[]> {
    if (this._managingOrgId) {
      return of([this._managingOrgId]);
    }

    // Step 1: Get perimeters for the incident
    const params = { body: { attributes: ['incidentId', 'perimeterId'], where: { incidentId } } };
    const findIncidentPerimeterUrl = `${ConfigurationManagerService.settings.BaseURL}db/findIncidentPerimeter`;

    return this.http.post<any>(findIncidentPerimeterUrl, params).pipe(
      switchMap(result => {
        const perimeterIds: string[] = (result.data.rows || [])
          .filter((p: any) => p.incidentId === incidentId)
          .map((p: any) => p.perimeterId);

        if (perimeterIds.length === 0) {
          return of([]); // No perimeters → return empty array
        }

        // Step 2: Get orgs associated with these perimeters
        const orgParams = { body: { attributes: ['organizationId'], where: { perimeterId: perimeterIds } } };
        const findOrganizationPerimeterUrl = `${ConfigurationManagerService.settings.BaseURL}db/findOrganizationPerimeter`;

        return this.http.post<any>(findOrganizationPerimeterUrl, orgParams).pipe(
          map(response => {
            const orgIds = (response.data.rows || []).map((r: any) => r.organizationId);
            const orgsOfPerimeterForIncident = this.getOrgDescendants(orgIds);
            return orgsOfPerimeterForIncident;
          })
        );
      }),
      catchError(error => {
        console.error('Error in getPerimeterIncidentOrgs', error);
        return throwError(() => error);
      })
    );
  }

  // Placeholder: get descendants of organization IDs
  private getOrgDescendants(orgIds: string[]): string[] {
    // TODO: implement logic to get descendants for the orgs
    // For now, just return the same orgIds
    return orgIds;
  }

  establishOrgIdToUseForLiveMode(descendantOrgIds: string[]): Observable<string> {
    if (this._managingOrgId) {
      return of(this._managingOrgId);
    }

    // Step 1: Fetch user's orgs that can create incidents
    const params = { body: { where: { code: 'papi.db.Incident.createPerimeter' } } };
    const url = `${ConfigurationManagerService.settings.BaseURL}db/getActionSessionWithOrganizationIds`;

    return this.http.post<any>(url, params).pipe(
      switchMap(response => {
        const orgIdsUserCanManageIncidents: string[] = response.data.rows[0]?.organizationIds || [];

        // Step 2: Intersection with descendantOrgIds
        const orgsAvailForIncident = orgIdsUserCanManageIncidents.filter(id => descendantOrgIds.includes(id));

        if (orgsAvailForIncident.length > 1) {
          // If multiple, call a dialog to let user choose
          return this.runChooseOrgDialog(orgsAvailForIncident);
        }

        // If only one, return it as Observable
        return of(orgsAvailForIncident[0]);
      }),
      map(_managingOrgId => {
        // Step 3: Save chosen value in state
        this._managingOrgId = _managingOrgId;
        return this._managingOrgId;
      })
    );
  }

  // Placeholder: implement dialog for user to choose org
  private runChooseOrgDialog(orgIds: string[]): Observable<string> {
    // Example: just return the first for now
    // You can replace with actual modal dialog that returns Observable<string>
    return of(orgIds[0]);
  }
   requestCampusActionSessionWithOrganizationIds(){
    const params = {
      attributes: ['code', 'id'],
      where: {
        $or: [
          {
            code: {
              $like: 'campus%'
            }
          }
        ]
      }
  };
    return this.http.post(ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ActionSessionWithOrganizationIds, params);
  }

  getCampusRoles(): Observable<any> {
    const url =
        ConfigurationManagerService.settings.BaseURL +
        ConfigurationManagerService.settings.GetCampusRoles;
    const body = {};
    return this.api.post<any>(url, body);
  }
}
